import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({ user: null, auth: null, isProAccount: false }),
})